import { LEGAL_COMPANY, LEGAL_VERSION } from "@/content/company";
import type { FormConsentRecord } from "@/lib/api/types";
import type { Locale } from "@/lib/i18n/config";

/** Build the consent audit record stored with every marketing lead form. */
export function buildFormConsentRecord(input: {
  consentText: string;
  locale: Locale;
  formSource: string;
}): FormConsentRecord {
  const origin =
    typeof window !== "undefined" ? window.location.origin : LEGAL_COMPANY.website;

  return {
    accepted: true,
    consentText: input.consentText,
    policyVersion: LEGAL_VERSION,
    privacyPolicyUrl: `${origin}${LEGAL_COMPANY.privacyUrl}`,
    termsUrl: `${origin}${LEGAL_COMPANY.termsUrl}`,
    locale: input.locale,
    pageUrl: typeof window !== "undefined" ? window.location.href : origin,
    referrer:
      typeof document !== "undefined" && document.referrer
        ? document.referrer
        : null,
    userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "unknown",
    acceptedAtClient: new Date().toISOString(),
    formSource: input.formSource,
  };
}
